import React from 'react';

import Typography from '../../library/typography/typography';

import { useDoesProductFit, useFitment } from '../../shared/hooks/hooks';

import { ProductData } from '../../shared/types/graphql-types';
import { FIT } from '../../shared/constants/fit';

import './product-contains-description.scss';

interface ProductContainsDescriptionProps {
  product: ProductData;
}

function ProductContainsDescription(props: ProductContainsDescriptionProps) {
  const { product } = props;
  const { code, fitmentPosition, unitOfMeasureDescription } = product || {};

  const { selectedFitment } = useFitment();
  const { doesFitEnumMap } = useDoesProductFit({
    fitment: selectedFitment,
    isCanonical: false,
    isStaggered: false,
    productCodes: [code]
  });
  const doesFit = doesFitEnumMap?.[code || ''] === FIT;

  return (
    <Typography
      className="product-contains-description"
      styleName="container"
      tag="span"
    >
      {unitOfMeasureDescription}
      {doesFit && fitmentPosition ? (
        <strong>&nbsp; {fitmentPosition.description}</strong>
      ) : null}
    </Typography>
  );
}

export default React.memo(ProductContainsDescription);
